import React from 'react';
import GeneratorTool from '../components/GeneratorTool'; // Import the tool

// --- ★ MODIFICATION: Accept 'onJobStarted' prop ---
const MugPage = ({ session, onJobStarted }) => {
    return (
        // Render the GeneratorTool, passing down the session
        // and setting the specific toolType for mugs
        <GeneratorTool 
          session={session} 
          toolType="mug" 
          onJobStarted={onJobStarted} // <-- Pass it down
        />
    );
};

export default MugPage;